import { createAction, props } from '@ngrx/store';
import {
    DeleteExaminations,
    ExaminationWorklistDTO,
    ExecutionWorkflow,
    QuestionListWorkflowDTO,
    SendToWorklistWorkflow,
    UndoExecutionWorkflow
} from '@se/models';
import { SearchParams, ToolbarAction } from '@se/platform';
import { Datasources } from '../models/datasources.model';
import { CmDialogModel } from '../models/dialog.model';

export enum ActionTypes {
    AnamnesticDataModelChangeAction = '[EXECUTION] anamnesticDataModelChange',
    AnamnesticFieldsChangeAction = '[EXECUTION] anamnesticFieldsChange',
    AuthenticateAndDeleteAction = '[EXECUTION] authenticateAndDelete',
    AuthenticateAndExecuteAction = '[EXECUTION] authenticateAndExecute',
    AuthenticateAndExecuteAsOtherTechnicianAction = '[EXECUTION] authenticateAndExecuteAsOtherTechnician',
    AuthenticateAndUndoExecutionAction = '[EXECUTION] authenticateAndUndoExecution',
    AuthenticateAndSendToWorklistAction = '[EXECUTION] authenticateAndSendToWorklist',
    CmDialogModelChangeAction = '[EXECUTION] cmDialogModelChange',
    OpenDirectAdmissionDialogAction = '[EXECUTION] openDirectAdmissionDialog',
    DatasourcesChangeAction = '[EXECUTION] datasourcesChange',
    DoNothingAction = '[EXECUTION] do nothing',
    OpenHomonymyNotificationAction = '[EXECUTION] openHomonymyNotification',
    OpenHomonymousExaminationsNotificationAction = '[EXECUTION] openHomonymousExaminationsNotification',
    OpenHomonymousExaminationsNotificationForExecutionAction = '[EXECUTION] openHomonymousExaminationsNotificationForExecution',
    OpenHomonymousExaminationsNotificationForAdmisionAction = '[EXECUTION] openHomonymousExaminationsNotificationForAdmision',
    OpenSelectTemplateDialogAction = '[EXECUTION] openSelectTemplateDialog',
    ResetStateAction = '[EXECUTION] resetState',
    RefreshWorklist = '[EXECUTION] refresh worklist',
    SetFilterParams = '[Execution] Set Search Params'
}

export const anamnesticDataModelChange = createAction(
    ActionTypes.AnamnesticDataModelChangeAction,
    props<{ data: CmDialogModel }>(),
);

export const anamnesticFieldsChange = createAction(
    ActionTypes.AnamnesticFieldsChangeAction,
    props<{ data: QuestionListWorkflowDTO[], selectedRows: ExaminationWorklistDTO[] }>(),
);

export const authenticateAndDelete = createAction(
    ActionTypes.AuthenticateAndDeleteAction,
    props<{ data: DeleteExaminations, selectedRows: ExaminationWorklistDTO[]; }>(),
);

export const authenticateAndExecute = createAction(
    ActionTypes.AuthenticateAndExecuteAction,
    props<{ data: ExecutionWorkflow, selectedRows: ExaminationWorklistDTO[]; }>(),
);

export const authenticateAndExecuteAsOtherTechnician = createAction(
    ActionTypes.AuthenticateAndExecuteAsOtherTechnicianAction,
    props<{ data: ExecutionWorkflow, userId: string, selectedRows: ExaminationWorklistDTO[] }>(),
);

export const authenticateAndUndoExecution = createAction(
    ActionTypes.AuthenticateAndUndoExecutionAction,
    props<{ data: UndoExecutionWorkflow, selectedRows: ExaminationWorklistDTO[] }>(),
);

export const authenticateAndSendToWorklist = createAction(
    ActionTypes.AuthenticateAndSendToWorklistAction,
    props<{ data: SendToWorklistWorkflow }>(),
);

export const cmDialogModelChange = createAction(
    ActionTypes.CmDialogModelChangeAction,
    props<{ data: CmDialogModel }>(),
);


export const openDirectAdmissionDialog = createAction(ActionTypes.OpenDirectAdmissionDialogAction);

export const datasourcesChange = createAction(ActionTypes.DatasourcesChangeAction, props<{ data: Datasources }>());

export const doNothing = createAction(ActionTypes.DoNothingAction);

export const openHomonymousExaminationsNotification = createAction(
    ActionTypes.OpenHomonymousExaminationsNotificationAction,
    props<{idExamination: string; otherExamination: ExaminationWorklistDTO[] }>(),
);

export const openHomonymousExaminationsNotificationForExecution = createAction(
    ActionTypes.OpenHomonymousExaminationsNotificationForExecutionAction,
    props<{idExamination: string; otherExamination: ExaminationWorklistDTO[], toolbarAction: ToolbarAction }>(),
);

export const openSelectTemplateDialog = createAction(
    ActionTypes.OpenSelectTemplateDialogAction,
    props<{ idExaminations: string[] }>(),
);

export const resetState = createAction(ActionTypes.ResetStateAction);

export const refreshWorklist = createAction(ActionTypes.RefreshWorklist);

export const setExecutionSearchParams = createAction(ActionTypes.SetFilterParams, props<{ params: SearchParams }>());
